import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
export function ProductSection() {
  const features = [{
    what: 'Protocolos naturales complementarios',
    why: 'Cubre fiebre, tos, gripe, resfriado, dolor de barriga y congestión — todo en un solo lugar'
  }, {
    what: 'Pasos ordenados',
    why: 'Elimina la parálisis por incertidumbre: qué hacer primero, qué hacer después'
  }, {
    what: 'Ingredientes simples',
    why: 'Sin necesidad de ir a farmacia a medianoche — usa lo que ya tienes'
  }, {
    what: 'Señales de alerta',
    why: 'Seguridad y tranquilidad para saber cuándo actuar en casa y cuándo ir al médico'
  }, {
    what: 'Formato digital inmediato',
    why: 'Disponible en 30 segundos en tu celular, tablet o computadora'
  }];
  return <section className="py-24 bg-cream relative" data-id="element-271">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="text-center mb-16" data-id="element-273">
          <span className="text-terracotta font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-274">
            Producto Principal
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-forest mb-4 font-serif" data-id="element-275">
            PequeSalud Natural
          </h2>
          <p className="text-xl text-forest/70 font-serif italic" data-id="element-276">
            "La guía que desearías haber tenido desde el primer día."
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-sage/10" data-id="element-277">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-278">
            {/* Image Side */}
            <div className="bg-sage/5 p-8 lg:p-12 flex items-center justify-center relative overflow-hidden" data-id="element-279">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-280"></div>
              <motion.img initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} src="https://cdn.magicpatterns.com/uploads/unZichhruR5hEhX3jhYG9B/pequesalud_shopify.png" alt="PequeSalud Natural Cover" className="w-full max-w-md shadow-2xl rounded-lg transform rotate-2 hover:rotate-0 transition-all duration-500" data-id="element-281" />
            </div>

            {/* Content Side */}
            <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-282">
              <div className="mb-8" data-id="element-283">
                <h3 className="text-2xl font-bold text-forest mb-4" data-id="element-284">
                  La Guía Completa de Apoyo Natural para Síntomas Infantiles
                </h3>
                <p className="text-forest/70" data-id="element-285">
                  Esta no es una colección de recetas de abuela. Es un sistema
                  estructurado de respuesta natural, diseñado específicamente
                  para el momento de crisis.
                </p>
              </div>

              <div className="space-y-6" data-id="element-286">
                {features.map((item, idx) => <div key={idx} className="flex gap-4" data-id="element-287">
                    <CheckCircle2 className="h-6 w-6 text-terracotta flex-shrink-0 mt-1" data-id="element-288" />
                    <div data-id="element-289">
                      <h4 className="font-bold text-forest text-lg" data-id="element-290">
                        {item.what}
                      </h4>
                      <p className="text-forest/60 text-sm" data-id="element-291">{item.why}</p>
                    </div>
                  </div>)}
              </div>

              <div className="mt-10 pt-8 border-t border-gray-100 text-center lg:text-left" data-id="element-292">
                <p className="font-serif text-xl text-terracotta font-medium" data-id="element-293">
                  No más búsquedas de Google a medianoche. No más dudas
                  paralizantes. Solo claridad. Solo acción.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}